/* eslint-disable no-undef */
import React from 'react';
import ReactDOM from 'react-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import thunkMiddleware from 'redux-thunk';
import { Provider as SugarProvider } from 'sugar-design';
import zhCN from 'sugar-design/lib/locale/zh_CN';
import enUS from 'sugar-design/lib/locale/en_US';

import { LOCALES, getBrowserI18nWithUtilsProvider, getI18n } from '@/utils/i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      refetchOnMount: false, // 重新获取数据当挂载一个新的组件实例时
      refetchOnWindowFocus: false,
    },
  },
});
const lang = getI18n().language;

export default function render(reducer, Routes, renderedElement) {
  const store = createStore(
    reducer,
    compose(
      applyMiddleware(thunkMiddleware),
      // eslint-disable-next-line no-undef
      __DEVTOOLS__ && typeof window === 'object' && typeof window.devToolsExtension !== 'undefined'
        ? window.devToolsExtension()
        : (f) => f
    )
  );

  const I18nWithUtilsProvider = getBrowserI18nWithUtilsProvider();

  ReactDOM.render(
    <Provider store={store}>
      <SugarProvider value={{ lang: lang === LOCALES.EN_US ? enUS : zhCN, theme: 'cyan' }}>
        <I18nWithUtilsProvider>
          <QueryClientProvider client={queryClient}>
            <Routes />
          </QueryClientProvider>
        </I18nWithUtilsProvider>
      </SugarProvider>
    </Provider>,

    renderedElement
  );
}
